var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyPerformance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0002 0.241 48.4647937 0.241 48.4647937 29.8303 0.0002 29.8303"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyPerformance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(20.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.759200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4282,10.4453 L46.7562,1.9343 C46.7122,1.6513 46.6082,1.3813 46.4532,1.1403 C46.3002,0.9123 46.1032,0.7163 45.8742,0.5643 C45.8102,0.5323 45.7432,0.5053 45.6742,0.4843 C45.5012,0.3833 45.3162,0.3083 45.1222,0.2603 C44.9412,0.2343 44.7572,0.2343 44.5762,0.2613 C44.4832,0.2483 44.3882,0.2463 44.2942,0.2543 L35.7822,1.9263 C34.6382,2.1423 33.8862,3.2453 34.1032,4.3883 C34.3192,5.5323 35.4212,6.2843 36.5652,6.0683 L39.9682,5.4023 C31.5062,17.7623 17.3142,25.3303 2.2502,25.3303 C1.0072,25.3303 0.0002,26.3373 0.0002,27.5803 C0.0002,28.8223 1.0072,29.8303 2.2502,29.8303 C18.7732,29.8303 34.3412,21.5453 43.6402,8.0063 L44.2862,11.2283 C44.5002,12.3703 45.5992,13.1223 46.7412,12.9083 C46.7442,12.9083 46.7462,12.9073 46.7482,12.9073 C46.9222,12.8733 47.0912,12.8173 47.2512,12.7413 C48.1222,12.3343 48.6062,11.3893 48.4282,10.4453",
    id: "Fill-1",
    fill: "#FCBC00",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.6885,44.7592 C1.4455,44.7592 0.4385,43.7512 0.4385,42.5092 L0.4385,35.6022 C0.4385,34.3602 1.4455,33.3522 2.6885,33.3522 C3.9315,33.3522 4.9385,34.3602 4.9385,35.6022 L4.9385,42.5092 C4.9385,43.7512 3.9315,44.7592 2.6885,44.7592",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6191,44.7592 C12.3761,44.7592 11.3691,43.7512 11.3691,42.5092 L11.3691,34.6022 C11.3691,33.3592 12.3761,32.3522 13.6191,32.3522 C14.8621,32.3522 15.8691,33.3592 15.8691,34.6022 L15.8691,42.5092 C15.8691,43.7512 14.8621,44.7592 13.6191,44.7592",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5493,44.7592 C23.3063,44.7592 22.2993,43.7512 22.2993,42.5092 L22.2993,30.9742 C22.2993,29.7312 23.3063,28.7242 24.5493,28.7242 C25.7923,28.7242 26.7993,29.7312 26.7993,30.9742 L26.7993,42.5092 C26.7993,43.7512 25.7923,44.7592 24.5493,44.7592",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4795,44.7592 C34.2365,44.7592 33.2295,43.7512 33.2295,42.5092 L33.2295,24.6022 C33.2295,23.3592 34.2365,22.3522 35.4795,22.3522 C36.7225,22.3522 37.7295,23.3592 37.7295,24.6022 L37.7295,42.5092 C37.7295,43.7512 36.7225,44.7592 35.4795,44.7592",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4097,44.7592 C45.1667,44.7592 44.1597,43.7512 44.1597,42.5092 L44.1597,18.6022 C44.1597,17.3592 45.1667,16.3522 46.4097,16.3522 C47.6527,16.3522 48.6597,17.3592 48.6597,18.6022 L48.6597,42.5092 C48.6597,43.7512 47.6527,44.7592 46.4097,44.7592",
    id: "Fill-12",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPerformance);
export default __webpack_public_path__ + "static/media/my-performance.9e25078bc287769819a44fbb05779453.svg";
export { ForwardRef as ReactComponent };